import React, { useEffect } from "react"
import { AppAntSwitch } from "@components"
import { reportFormData, useCsv } from "Pages/ReportsAlerts/Reports/@signals"


export default function SwitchCSV() {

	useEffect(() => {
		useCsv.value = !!reportFormData.peek().customConfigData?.length
	}, [])

	return <AppAntSwitch
		trueText="Use CSV"
		checked={useCsv.value}
		onChange={e => useCsv.value = e.target.checked}
	/>
}